module.exports = __webpack_public_path__ + "img/744.4d7d3bbb.jpg";